import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "nativewind/jsx-runtime";
import React from 'react';
import styled from 'styled-components/native';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
import FloorSelect from '../../PlaceReviewFormScreen/components/FloorSelect';
import { FLOOR_OPTIONS, STANDALONE_BUILDING_OPTIONS } from '../constants';
import OptionsV2 from './OptionsV2';
/**
 * Shared floor question UI used by both PlaceFormV2 (PA registration)
 * and ReportCorrectionForm (correction report).
 *
 * Contains:
 * - Floor option selection (1층, 다른층, 여러층, 단독건물)
 * - Floor number picker (when "다른층" is selected)
 * - Standalone building type selection (when "단독건물" is selected)
 */
export default function FloorQuestionUI({ floorOption, selectedFloor, standaloneType, onChangeFloorOption, onChangeSelectedFloor, onChangeStandaloneType, }) {
    return (_jsxs(_Fragment, { children: [_jsx(OptionsV2, { value: floorOption, columns: 1, options: FLOOR_OPTIONS.map(option => ({
                    label: option.label,
                    value: option.key,
                })), onSelect: onChangeFloorOption }), floorOption === 'otherFloor' && (_jsxs(AdditionalQuestionArea, { children: [_jsx(SubQuestionText, { children: "\uADF8\uB7FC \uBA87\uCE35\uC5D0 \uC788\uB294 \uC7A5\uC18C\uC778\uAC00\uC694?" }), _jsx(FloorSelect, { value: selectedFloor, onChange: onChangeSelectedFloor, minAbsoluteFloor: 2 })] })), floorOption === 'standalone' && (_jsxs(AdditionalQuestionArea, { children: [_jsx(SubQuestionText, { children: "\uC5B4\uB5A4 \uC720\uD615\uC758 \uB2E8\uB3C5\uAC74\uBB3C\uC778\uAC00\uC694?" }), _jsx(OptionsV2, { value: standaloneType, columns: 2, options: STANDALONE_BUILDING_OPTIONS.map(option => ({
                            label: option.label,
                            value: option.key,
                        })), onSelect: onChangeStandaloneType })] }))] }));
}
const AdditionalQuestionArea = styled.View `
  margin-top: 20px;
  gap: 20px;
`;
const SubQuestionText = styled.Text `
  font-size: 16px;
  font-family: ${font.pretendardBold};
  color: ${color.black};
`;
